import React from 'react'
import Navigation from '../layout/Navigation'

const Projects = () => {
    return (
        <>
            <Navigation title="Raunak Kesarwani" />
        </>
    )
}

export default Projects;